// Utils
import { prop } from '../../../common/utils/immutableHelper';

export const getResourceName = prop('resourceName');
export const getMilanoteUserId = prop('userId');
